import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PlayersPage from "@/pages/PlayersPage";
import PlayerProfile from "@/pages/PlayerProfile";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* AuthProvider korunuyor (mevcut komponentler useAuth çağırıyor)
            ama artık login yok — herkes misafir olarak geziyor. */}
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PlayersPage />} />
            <Route path="/player" element={<PlayersPage />} />
            <Route path="/player/:tag" element={<PlayerProfile />} />
            {/* Eski URL'ler kaldırıldı — kök sayfaya yönlendir */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        richColors
        theme="dark"
        position="top-right"
        toastOptions={{
          classNames: {
            toast:
              "bg-card border border-white/10 text-foreground font-medium",
          },
        }}
      />
    </div>
  );
}

export default App;
